/**
 * @param user
 * @returns {boolean}
 */
export const isUserAdmin = (user) => {
    const adminRoles = [
        constants.user_role.SUPER_ADMIN,
        constants.user_role.ADMIN,
        constants.user_role.CORE_ADMIN,
        constants.user_role.SUPER_GOD_ADMIN,
        constants.user_role.SUPPORT,
    ];

    const userRoles = _.get(user, 'roles', []).map(r => r.id)

    return _.intersection(adminRoles, userRoles).length > 0;
};